import React from "react";
import { Helmet } from "react-helmet";
import type { PageEntry } from "../shared/types";
import { CHANGELOG_RSS, markdownUrl, siteUrl } from "../shared/paths";
import { COPY } from "../copy";
import { siteOrigin } from "./origin";

/**
 * The page's `<head>` (design §0.2 "URL ve makine yüzeyleri"): title, description (the subtitle),
 * canonical, Open Graph, the `.md` twin, the changelog feed and the breadcrumb as structured data.
 * The site origin is `siteOrigin()` — the same one the build writes the sitemap with.
 */

export const Head = ({ entry }: { entry: PageEntry }) => {
  const url = `${siteOrigin()}${siteUrl(entry.path)}`;
  const title = `${entry.title} · ${COPY.siteName}`;
  const crumbs = [...entry.breadcrumb, entry.title];
  const breadcrumb = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((name, i) => ({ "@type": "ListItem", position: i + 1, name, ...(i === crumbs.length - 1 ? { item: url } : {}) })),
  };

  return (
    <Helmet>
      <title>{title}</title>
      {entry.subtitle ? <meta name="description" content={entry.subtitle} /> : null}
      <link rel="canonical" href={url} />
      <link rel="alternate" type="text/markdown" href={markdownUrl(entry.path)} />
      {entry.kind === "changelog" ? <link rel="alternate" type="application/rss+xml" href={CHANGELOG_RSS} /> : null}
      <meta property="og:title" content={title} />
      {entry.subtitle ? <meta property="og:description" content={entry.subtitle} /> : null}
      <meta property="og:type" content="article" />
      <meta property="og:url" content={url} />
      <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
    </Helmet>
  );
};
